import "./content-section.scss";

document.addEventListener("DOMContentLoaded", () => {
  // Select all collapsible section headers
  const collapsibleSections = document.querySelectorAll(
    ".content-section-block.is-collapsible .section-header-toggleable"
  );

  collapsibleSections.forEach((header) => {
    header.addEventListener("click", (event) => {
      // Prevent event if clicked on a link or button within the header
      if (event.target.closest("a, button")) return;

      const section = header.closest(".content-section-block");
      const toggleButton = header.querySelector(".section-toggle");
      const contentSection = section.querySelector(".content-section");

      // Toggle collapsed state
      section.classList.toggle("is-collapsed");

      // Update aria-expanded attribute
      const isCollapsed = section.classList.contains("is-collapsed");
      toggleButton.setAttribute("aria-expanded", !isCollapsed);
      contentSection.setAttribute("aria-hidden", isCollapsed);

      // Rotate toggle icon
      const toggleIcon = toggleButton.querySelector(".toggle-icon");
      toggleIcon.style.transform = isCollapsed
        ? "rotate(-90deg)"
        : "rotate(0deg)";
    });
  });
});
